window.WeaHrm4Formal = false;
window.HrmGroupCol = 2; //人力布局(1、一行2列，2、一行4列)
window.HrmLabelCol = 6;
window.HrmWrapperCol = 15;
window.inputType = {
  inputType: 'MULTILANG',
  isBase64: true
} //, isBase64: true}; //'MULTILANG'; //'NORMAL';
import {
  WeaLocaleProvider
} from 'ecCom';
import Route from 'react-router/lib/Route';
import IndexRedirect from "react-router/lib/IndexRedirect"
import Home from './components/Home';
import Checking from './components/Checking'; // 考勤
import BirthdayInfo from './components/BirthdayInfo';
import Group from './components/Group';
import Shift from './components/Shift'; // 排班
import Outside from './components/Outside'; // 外勤
import Total from './components/Total'; //工作历程
import Online from './components/Online'; // 在线人员
import Underling from './components/Underling'; //我的下属
import TrainRecord from './components/TrainRecord'; //培训记录
import RewardsRecord from './components/RewardsRecord'; //奖惩考核
import Finance from './components/Finance'; //我的工资
import RoelSet from './components/card/RoleSet'; //角色设置
import SystemInfo from './components/card/SystemInfo'; //系统信息
import SystemInfo4Formal from './components/card/SystemInfo4Formal'; //系统信息
import Password from './components/Password'; //密码修改、设置
import AddressBook from './components/AddressBook'; //通讯录
import AddressBookForOrgChart from './components/AddressBookForOrgChart'; //通讯录FOR ORG CHART
import Add from './components/add/index'; // 新建人员
// 卡片
import Card from './components/card/index'; // 卡片
import CardInfo from './components/card/Info'; // 基本信息
import CardInfo4Formal from './components/card/Info4Formal_new'; // 基本信息
import CardPersonal from './components/card/Personal'; // 个人信息
import CardWork from './components/card/Work'; // 工作信息
import CardSystemInfo from './components/card/SystemInfo'; //系统信息
import CardSystemInfo4Formal from './components/card/SystemInfo4Formal'; //系统信息
import CardFinance from './components/Finance'; //我的工资
import CardCheckingOld from './components/Checking'; // 旧考勤
import CardCheckingNew from '../hrmAttendance/components/Checking'; // 新考勤
import CardTrainrecord from './components/TrainRecord'; //培训记录
import CardRewardsRecord from './components/RewardsRecord'; //奖惩考核
import CardRoelSet from './components/card/RoleSet'; //角色设置
import CardTotal from './components/Total'; //工作历程
import SystemCard from './components/card/SystemCard'; //系统管理员卡片
import AddGroup from './components/card/Group'; //常用组
//报表
import BasicConditionAnalysis from './components/report/BasicConditionAnalysis'; //基本状况分析
import ChangeRelatedReport from './components/report/ChangeRelatedReport'; //人员变动情况
import ConstRpSubSearch from './components/report/ConstRpSubSearch'; //统计子表
import RpSubSearch from './components/report/RpSubSearch'; //统计子表--自定义
import ScheduleDiffReport from './components/report/ScheduleDiffReport'; //考勤报表
import ScheduleDiffReport4Formal from './components/report/ScheduleDiffReport4Formal'; //正式系统考勤报表
import ScheduleDiffMonthAttDetail from './components/report/ScheduleDiffMonthAttDetail'; //考勤月报表
import OrgChart from './components/orgChart/index'; //组织图表
import BindTokenKey from './components/BindTokenKey'; //
import ForgetPassword from './components/forgetPassword/index'; //忘记密码
import Applicant from './components/applicant/index'; //应聘人员
import Usedemand from './components/useDemand/index'; //用工需求
import TimeWageSummary from './components/timeWageSummary/index'; //时间工资汇总
import StaffPayrollSummary from './components/staffPayrollSummary/index'; //人员工资汇总
import spaGroup from './components/group/index'; //新建、编辑常用组单页
import GroupAdvice from './components/groupAdvice/index'; //常用组建议
import './style/index';
import './util/index';
import stores from './stores/index';
const getLocaleLabel = WeaLocaleProvider.getLocaleLabel.bind(this, 'hrm');
const HrmRoute = (
  <Route name="hrm" breadcrumbName="人事" path="hrm" onEnter={getLocaleLabel} component={Home}>
    <Route name="addressBook" breadcrumbName="通讯录" path="addressBook" component={AddressBook}/>
    <Route name="orgStaff" breadcrumbName="通讯录FOR ORG CHART" path="orgStaff" component={AddressBookForOrgChart}/>
    <Route name="add" breadcrumbName="新建人员" path="add" component={Add}/>
    <Route name="card" path="card" component={ Card }>
      <IndexRedirect to="cardInfo"/>
      <Route name='cardInfo' path='cardInfo' component={window.WeaHrm4Formal?CardInfo4Formal:CardInfo}/>
      <Route name='cardInfoId' path='cardInfo/:hrmId' component={window.WeaHrm4Formal?CardInfo4Formal:CardInfo}/>
      <Route name='cardPersonal' path='cardPersonal' component={CardPersonal}/>
      <Route name='cardPersonalId' path='cardPersonal/:hrmId' component={CardPersonal}/>
      <Route name='cardWork' path='cardWork' component={CardWork}/>
      <Route name='cardWorkId' path='cardWork/:hrmId' component={CardWork}/>
      <Route name="cardSystemInfo" path='cardSystemInfo' component={window.WeaHrm4Formal?CardSystemInfo4Formal:CardSystemInfo}/>
      <Route name="cardSystemInfoId" path='cardSystemInfo/:hrmId' component={window.WeaHrm4Formal?CardSystemInfo4Formal:CardSystemInfo}/>
      <Route name="cardFinance" path='cardFinance' component={Finance}/>
      <Route name="cardFinanceId" path='cardFinance/:hrmId' component={Finance}/>

      <Route name="cardChecking" path='cardChecking' component={CardCheckingOld}/>
      <Route name="cardCheckingId" path='cardChecking/:hrmId' component={CardCheckingOld}/>
      
      <Route name="cardCheckingN" path='cardCheckingN' component={CardCheckingNew}/>
      <Route name="cardCheckingNId" path='cardCheckingN/:hrmId' component={CardCheckingNew}/>
      
      <Route name="cardTrainRecord" path='cardTrainRecord' component={CardTrainrecord}/>
      <Route name="cardTrainRecordId" path='cardTrainRecord/:hrmId' component={CardTrainrecord}/>
      <Route name="cardRewardsRecord" path='cardRewardsRecord' component={CardRewardsRecord}/>
      <Route name="cardRewardsRecordId" path='cardRewardsRecord/:hrmId' component={CardRewardsRecord}/>
      <Route name="cardRoleSet" path='cardRoleSet' component={CardRoelSet}/>
      <Route name="cardRoleSetId" path='cardRoleSet/:hrmId' component={CardRoelSet}/>
      <Route name="cardTotal" path='cardTotal' component={CardTotal}/>
      <Route name="cardTotalId" path='cardTotal/:hrmId' component={CardTotal}/>
      <Route name="systemCard" path="systemCard" component={SystemCard}/>
      <Route name="systemCardId" path="systemCard/:hrmId" component={SystemCard}/>
      <Route name="addGroup" path="addGroup" component={AddGroup}/>
      <Route name="addGroupId" path="addGroup/:hrmId" component={AddGroup}/>
    </Route>
    <Route name="report" path="report">
      <Route name="basicConditionAnalysis" path="basicConditionAnalysis" component={BasicConditionAnalysis}/>
      <Route name="departmentStatistics" path="departmentStatistics" component={BasicConditionAnalysis}/>
      <Route name="postStatistics" path="postStatistics" component={BasicConditionAnalysis}/>
      <Route name="jobStatusStatistics" path="jobStatusStatistics" component={BasicConditionAnalysis}/>
      <Route name="add" path="add" component={ChangeRelatedReport}/>
      <Route name="confirmation" path="confirmation" component={ChangeRelatedReport}/>
      <Route name="transfer" path="transfer" component={ChangeRelatedReport}/>
      <Route name="renew" path="renew" component={ChangeRelatedReport}/>
      <Route name="rehire" path="rehire" component={ChangeRelatedReport}/>
      <Route name="loss" path="loss" component={ChangeRelatedReport}/>
      <Route name="contract" path="contract" component={ChangeRelatedReport}/>
    </Route>
    <Route name="checking" breadcrumbName="我的考勤" path="checking" component={Checking}/>
    <Route name="birthdayinfo" breadcrumbName="人员生日" path="birthdayinfo" component={BirthdayInfo}/>
    <Route name="group" breadcrumbName="人力资源" path="group" component={Group}/>
    <Route name="shift" breadcrumbName="我的排班" path="shift" component={Shift}/>
    <Route name="outside" breadcrumbName="外勤签到" path="outside" component={Outside}/>
    <Route name="total" breadcrumbName="工作历程" path="total" component={Total}/>
    <Route name="online" breadcrumbName="在线人员" path="online" component={Online}/>
    <Route name="password" breadcrumbName="密码修改和设置" path="password" component={Password}/>
    <Route name="underling" breadcrumbName="我的下属" path="underling" component={Underling}/>
    <Route name="underlingId" breadcrumbName="我的下属" path="underling/:hrmId" component={Underling}/>
    <Route name="trainrecord" breadcrumbName="培训记录" path="trainrecord" component={TrainRecord}/>
    <Route name="rewardsrecord" breadcrumbName="奖惩考核" path="rewardsrecord" component={RewardsRecord}/>
    <Route name="rewardsrecordId" breadcrumbName="奖惩考核" path="rewardsrecord/:hrmId" component={RewardsRecord}/>
    <Route name="finance" breadcrumbName="我的工资" path="finance" component={Finance}/>
    <Route name="roleset" breadcrumbName="角色设置" path="roleset" component={RoelSet}/>
    <Route name="systeminfo" breadcrumbName="系统信息" path="systeminfo" component={window.WeaHrm4Formal?SystemInfo4Formal:SystemInfo}/>
    <Route name="systeminfoId" breadcrumbName="系统信息" path="systeminfo/:hrmId" component={window.WeaHrm4Formal?SystemInfo4Formal:SystemInfo}/>
    <Route name="constrpsubsearch" breadcrumbName="统计子表" path="constrpsubsearch/:scopeId" component={ConstRpSubSearch}/>
    <Route name="rpsubsearch" breadcrumbName="统计子表--自定义" path="rpsubsearch" component={RpSubSearch}/>
    <Route name="schedulediffreport" breadcrumbName="考勤报表" path="schedulediffreport" component={window.WeaHrm4Formal?ScheduleDiffReport4Formal:ScheduleDiffReport}/>
    <Route name="schedulediffmonthattdetail" breadcrumbName="考勤报表" path="schedulediffmonthattdetail" component={ScheduleDiffMonthAttDetail}/>
    <Route name="orgChart" breadcrumbName="组织图表" path="orgChart" component={OrgChart}/>
    <Route name="BindTokenKey" breadcrumbName="令牌绑定" path="BindTokenKey" component={BindTokenKey}/>
    <Route name="forgetPassword" breadcrumbName="忘记密码" path="forgetPassword" component={ForgetPassword}/>
    <Route name="applicant" breadcrumbName="应聘人员" path="applicant" component={Applicant}/>
    <Route name="usedemand" breadcrumbName="用工需求" path="usedemand" component={Usedemand}/>
    <Route name="timeWageSummary" breadcrumbName="时间工资汇总" path="timeWageSummary" component={TimeWageSummary}/>
    <Route name="staffPayrollSummary" breadcrumbName="人员工资汇总" path="staffPayrollSummary" component={StaffPayrollSummary}/>
    <Route name="operateGroup" breadcrumbName="新建、编辑常用组单页" path="operateGroup" component={spaGroup}/>
    <Route name="groupAdvice" breadcrumbName="常用组建议" path="groupAdvice" component={GroupAdvice}/>
  </Route>
)
module.exports = {
  Route: HrmRoute,
  store: stores
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/index.js